<template>
  <div>
    <v-toolbar flat color="white" class="elevation-2">
      <v-toolbar-items class="hidden-sm-and-down">
        <span v-for="(item, index) in datatable.header.options" :key="index">
          <span v-if="item.hidden == ''">
            <v-btn v-if="item.action" :color="item.color" small dark class="mr-1 mt-3" @click="action(item)">
              {{ item.title }}
              <v-icon right dark v-if="item.icon">{{ item.icon }}</v-icon>
            </v-btn>
            <v-menu v-else offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="teal darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  small>
                  {{ item.title }} <v-icon right dark>{{ item.icon }}</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="(option, index) in item.options"
                  :key="index"
                  @click="action(option)"
                  link
                  dense>
                  <v-list-item-icon>
                    <v-icon>{{ option.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>{{ option.title }}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-menu>
          </span>
        </span>
      </v-toolbar-items>

      <span class="hidden-md-and-up">
        <v-menu>
          <template v-slot:activator="{ attrs, on }">
            <v-app-bar-nav-icon
              v-bind="attrs"
              v-on="on"
              small>
            </v-app-bar-nav-icon>
          </template>
          <v-list dense>
            <span v-for="(item, index) in datatable.header.options" :key="index">
              <span v-if="item.hidden == ''">
                <v-list-item v-if="item.action" @click="action(item)" link dense>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-subtitle>{{ item.title }}</v-list-item-subtitle>
                </v-list-item>
                <v-list-group v-else :value="true" no-action sub-group>
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title
                        >{{ item.title }}
                        <v-icon right dark>{{
                          item.icon
                        }}</v-icon></v-list-item-title
                      >
                    </v-list-item-content>
                  </template>
                  <v-list-item
                    v-for="(option, index) in item.options"
                    :key="index"
                    @click="action(option)"
                    link
                    dense
                  >
                    <v-list-item-icon>
                      <v-icon>{{ option.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle>{{
                      option.title
                    }}</v-list-item-subtitle>
                  </v-list-item>
                </v-list-group>
              </span>
            </span>
          </v-list>
        </v-menu>
      </span>

      <v-spacer></v-spacer>

      <v-text-field
        v-model="buscar"
        search-input="search"
        label="Buscar"
        class="inputSearch"
        clearable
        outlined
        dense>
      </v-text-field>
    </v-toolbar>

    <v-data-table
      v-model="datatable.modelMain"
      :show-select="datatable.showSelect"
      :single-select="datatable.singleSelect"
      :headers="datatable.header.titles"
      :items="datatable.body.data"
      :hide-default-footer="!datatable.footer.paging"
      :footer-props="footer"
      :search="buscar"
      :loading="datatable.header.loading"
      loading-text="Cargando por favor espere"
      class="elevation-1"
      dense
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" icon="warning">
          Lo siento, no hay registros para mostrar :(
        </v-alert>
      </template>
      <template v-slot:item.Status="{ item }">
        <v-chip :color="item.last_movement.estatus.color" dark>
          {{ item.last_movement.estatus.estatus }}
        </v-chip>
      </template>
      <template v-slot:item.Activo="{ item }">
        <v-chip
          class="ma-1"
          :color="item.activo == 'si' ? 'success' : 'error'"
          outlined
          label
          dark>
          {{ item.activo }}
        </v-chip>
      </template>

      <template v-slot:item.Created="{ item }">
        {{ convertDate(item.created_at) }}
      </template>
      <template v-slot:item.Updated="{ item }">
        {{ convertDate(item.updated_at) }}
      </template>

      <template v-slot:item.FieldDinamicData="{ item, header }">
        <span class="black--text font-weight-bold">
          {{ events(header, item) }}
        </span>
      </template>

      <template v-slot:item.Actions="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              color="teal darken-1"
              class="white--text pa-3"
              v-bind="attrs"
              v-on="on"
              x-small>
              Acciones
            </v-btn>
          </template>
          <v-list dense>
            <span v-for="(event, index) in datatable.body.actions" :key="index">
              <v-list-item v-if="event.hidden == ''" link @click="items({ body: event, action: event.action, item: item })" dense>
                <v-list-item-title>
                  <v-icon :color="event.color">{{ event.icon }}</v-icon>
                  {{ event.title }}
                </v-list-item-title>
              </v-list-item>
            </span>
          </v-list>
        </v-menu>
      </template>

      <template #footer.page-text="props">
        {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { NumberUtils } from '@/mixins/NumberUtilsMixin'
export default {
  mixins: [NumberUtils],
  name: 'TableMain',
  props: ['datatable', 'onSuccess', 'itemsAction'],
  data: () => ({
    expand: false,
    buscar: '',
    footer: {
      showFirstLastPage: true,
      'items-per-page-text': 'Registros por página'
    }
  }),
  methods: {
    action (item) {
      this.onSuccess(item)
    },
    items (item) {
      this.itemsAction(item)
    },
    convertDate (date) {
      const dateString = new Date(date).toISOString().substr(0, 10)
      const timeString = new Date(date).toLocaleTimeString()
      return `${dateString} ${timeString}`
    },
    events (header, item) {
      const fields = header.field.split('.')
      if (fields.length > 1) {
        const obj = item[fields[0]]
        const f = fields[1]
        return this[header.action](f, obj)
      }
      return this[header.action](header.field, item)
    },

    FormatNumberMoney (val, item) {
      if (typeof item[val] === 'string') {
        const valor = parseFloat(item[val])
        const number = this.intlRound(valor, 2)
        return `$ ${number}`
      }
      const number = this.intlRound(item[val], 2)
      return `$ ${number}`
    }
  }
}
</script>

<style>
.inputSearch {
  padding-top: 25px !important;
}
</style>
